module.exports = __webpack_public_path__ + "img/duck-pink.a6fca8c5.svg";